module.exports = ".input {\n  height: 15px;\n  border: 0px; }\n"